// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"styles-module__inputWrapper___365o0","input":"styles-module__input___2tBec"};